import React from 'react';
import { IconCalendar, IconClock } from '@tabler/icons-react';

import { ReservationRow, ReservationRowText, ReservationScheduleGroup } from '../styles';

export type ReservationScheduleRowProps = {
  date: string;
  time: string | null;
};

export const ReservationScheduleRow = (props: ReservationScheduleRowProps) => {
  const { date, time } = props;

  return (
    <ReservationScheduleGroup data-testid='reservation-schedule'>
      <ReservationRow>
        <IconCalendar size={20} aria-hidden />
        <ReservationRowText>{date}</ReservationRowText>
      </ReservationRow>

      {time ? (
        <ReservationRow>
          <IconClock size={20} aria-hidden />
          <ReservationRowText>{time}</ReservationRowText>
        </ReservationRow>
      ) : null}
    </ReservationScheduleGroup>
  );
};

export default ReservationScheduleRow;
